const RedoIcon = () => `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
  <path d="M19 8.00586L8 8.00586C5.23858 8.00586 3 10.2444 3 13.0059V13.0059C3 15.7673 5.23858 18.0059 8 18.0059L15.5 18.0059" stroke="currentColor" stroke-width="2"/>
  <path d="M15.5 12.5059L20 8.00586L15.5 3.50586" stroke="currentColor" stroke-width="2"/>
  </svg>`;
export default RedoIcon;
